import {
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form,
  Modal
} from "reactstrap";
import React, { useState } from "react";
import { addPickupAWB, getAWBs } from "reducers/Clients";

import CustomButton from "components/Button";
import TextInput from "components/TextInput";
import { connect } from "react-redux";
import { toast } from "react-toastify";

const AWBSuggestion = ({ open, onClose, getAWBs, onSubmit, buttonLoader }) => {
  const [suggestion, setSugestion] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [awbDetail, setAWBDetail] = useState({});
  const [searchText, setSearchText] = useState("");

  const handleSearch = async (e) => {
    setSearchText(e.target.value);
    if (e.target.value.length) {
      try {
        const res = await getAWBs(e.target.value);
        setSugestion(res);
        setDropdownOpen(true);
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleAWBSelection = async () => {
    setDropdownOpen(false);
    onSubmit(awbDetail);
  };

  const handleSelection = (data) => {
    setAWBDetail(data);
    setSearchText(data.AWBNo);
    setDropdownOpen(false);
  };

  return (
    <Modal zIndex={2000} centered isOpen={open} toggle={onClose}>
      <Form style={{ padding: "20px" }}>
        <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(false)}>
          <DropdownToggle
            tag="span"
            data-toggle="dropdown"
            aria-expanded={dropdownOpen}>
            <TextInput
              value={searchText}
              label={"Search here"}
              placeholder="Search by AWB"
              onChange={handleSearch}
            />
          </DropdownToggle>
          <DropdownMenu style={{ transform: "none", width: "100%" }}>
            {suggestion.length > 0 &&
              suggestion.map((data) => (
                <div
                  key={data.id}
                  onClick={() => handleSelection(data)}
                  style={{ padding: "5px 10px", cursor: "pointer" }}>
                  {data.AWBNo}
                </div>
              ))}
          </DropdownMenu>
        </Dropdown>
        <div className="d-flex justify-content-between">
          <Button color="link" className="btn-link-dark" onClick={onClose}>
            Close
          </Button>
          <CustomButton
            label={buttonLoader ? "Loading..." : "Done"}
            disabled={!searchText || buttonLoader}
            onClick={handleAWBSelection}
          />
        </div>
      </Form>
    </Modal>
  );
};
const mapDispatchToProps = {
  getAWBs,
  addPickupAWB
};

export default connect(null, mapDispatchToProps)(AWBSuggestion);
